import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { CURRENCY_SYMBOLS } from "@/config/constants";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Single source of truth for currency symbols.
 * 1. Prefer the curated `CURRENCY_SYMBOLS` map (deterministic, embed-safe).
 * 2. Fall back to `Intl.NumberFormat` for locales without a curated entry.
 * 3. Finally fall back to the ISO code itself.
 *
 * Widgets must import this helper instead of accessing `CURRENCY_SYMBOLS`
 * directly so we never end up with two parallel sources of truth.
 */
export function currencySymbol(code: string): string {
  if (CURRENCY_SYMBOLS[code]) return CURRENCY_SYMBOLS[code];
  try {
    const parts = new Intl.NumberFormat("en", {
      style: "currency",
      currency: code,
      currencyDisplay: "narrowSymbol",
    }).formatToParts(0);
    return parts.find((p) => p.type === "currency")?.value || code;
  } catch {
    return code;
  }
}
